module.exports = __webpack_public_path__ + "static/investmentsMobileBox-3f5989bfed2ed32786eeda02db6e8779.png";